// TODO: Merge this into the stepper package after migrating checkout to app router
'use client';

import StepperNavbar from '@nrdy-marketing-engine/navbar/src/stepper-navbar';
import useStepperValues from '@nrdy-marketing-engine/stepper/src/hooks/use-stepper-values';

/**
 * A wrapper around StepperNavbar which adds event listeners for SET_STEP and SET_TOTAL_STEPS
 * so that we can update the activeStep and totalSteps props of StepperNavbar from anywhere
 * else in the app.
 */
function Stepper() {
  const { step, totalSteps } = useStepperValues();
  return <StepperNavbar activeStep={step} totalSteps={totalSteps} />;
}

export default Stepper;
